import React from 'react';
import {
  EncounterFinancialDetailsDTO,
  PatientDTO,
} from 'dtos';
import {
  formatMoney,
} from '@populateui/utils';
import {
  paymentsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import Button from 'pages/Dashboard/components/Button';

type Props = {
  patient?: Partial<PatientDTO>;
  encounter?: Partial<EncounterFinancialDetailsDTO>;
  due?: number | null;
};

export default function Checkout({
  patient,
  due,
  encounter,
}: Props) {
  const { encounterId } = encounter ?? {};
  const onCollect = () => {
    paymentsEventChannel.emit('onPaymentDialogOpen', {
      patient: patient!,
      encounterId: encounterId!,
    });
  };

  return (
    <div className="items-center flex justify-end gap-2">
      <Button
        className="!border-secondary disabled:!border-gray-300 flex gap-1 !px-2.5 !py-0.5 !min-w-[120px]"
        variant="outlined"
        color="primary"
        onClick={onCollect}
      >
        Collect
        {due === 0 ? '' : ` ${formatMoney(due ?? 0)}`}
        {' '}
      </Button>
    </div>
  );
}
